import { IconDefinition } from "./types";

const houseChimney: IconDefinition = {
  iconName: "house-chimney",
  width: 576,
  height: 512,
  svgPathData:
    "M304.4 6.1l-16-14.4-16 14.4-232 208-17.9 16 32 35.7c13.6-12.2 22.2-19.9 25.8-23.2l0 269.3 416 0 0-269.3c3.7 3.3 12.3 11 25.8 23.2l32-35.7c-8.2-7.4-27.5-24.7-57.9-51.9l0-114.2-48 0 0 71.2-144-129.1zm144 193.6l0 264.3-64 0 0-176.5-192 0 0 176.5-64 0 0-264.3 160-143.5 160 143.4zM240.4 464l0-128.5 96 0 0 128.5-96 0z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "house-chimney",
  unicode: 0xe3af,
};

export { houseChimney };
